import Supplier from './SupplierDetailPage';

export default Supplier;
